import React from "react";

import { MediaKind, MenuItemListDto } from "services/menu/restModels";

import { localizedText } from "shared/lib/localizedMap";
import { IconButton, ImageIcon, MoreIcon, ToggleSwitch } from "shared/ui";

import {
    Body,
    Card,
    Clickable,
    Description,
    Footer,
    Meta,
    NoPhoto,
    Photo,
    Price,
    StopBadge,
    Title,
    TitleRow,
} from "./styles";

interface MenuItemTileProps {
    item: MenuItemListDto;
    locale: string;
    formatPrice: (price: number) => string;
    toggling: boolean;
    onOpen: (item: MenuItemListDto) => void;
    onToggleStopList: (item: MenuItemListDto) => void;
    onOpenActions: (item: MenuItemListDto, anchorEl: HTMLElement) => void;
}

const modifiersLabel = (count: number): string => {
    if (count === 0) return "Без модификаторов";
    if (count === 1) return "1 набор модификаторов";
    if (count < 5) return `${count} набора модификаторов`;

    return `${count} наборов модификаторов`;
};

export const MenuItemTile = ({
    item,
    locale,
    formatPrice,
    toggling,
    onOpen,
    onToggleStopList,
    onOpenActions,
}: MenuItemTileProps) => {
    const description = localizedText(item.description, locale);

    return (
        <Card>
            <Clickable $stopped={item.isInStopList} onClick={() => onOpen(item)}>
                <Photo>
                    {item.previewPhotoUrl && item.previewPhotoKind === MediaKind.video ? (
                        <video src={item.previewPhotoUrl} preload="metadata" muted />
                    ) : item.previewPhotoUrl ? (
                        <img src={item.previewPhotoUrl} alt="" />
                    ) : (
                        <NoPhoto>
                            <ImageIcon />
                            нет фото
                        </NoPhoto>
                    )}
                    {item.isInStopList && <StopBadge>Стоп-лист</StopBadge>}
                </Photo>

                <Body>
                    <TitleRow>
                        <Title>{localizedText(item.name, locale)}</Title>
                        <Price>{formatPrice(item.sellPrice.price)}</Price>
                    </TitleRow>

                    {description && <Description>{description}</Description>}

                    <Meta $muted={item.modifierSetsCount === 0}>
                        {modifiersLabel(item.modifierSetsCount)}
                    </Meta>
                </Body>
            </Clickable>

            <Footer>
                <ToggleSwitch
                    checked={!item.isInStopList}
                    disabled={toggling}
                    ariaLabel={
                        item.isInStopList ? "Вернуть в продажу" : "Убрать из продажи"
                    }
                    onChange={() => onToggleStopList(item)}
                />
                <IconButton
                    label="Действия с позицией"
                    onClick={(event) => onOpenActions(item, event.currentTarget)}
                >
                    <MoreIcon />
                </IconButton>
            </Footer>
        </Card>
    );
};
